import { faHandHoldingDollar, faLocationDot, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import "./UserInfo.css";

const UserInfo = () => {
    return (
        <section className="UserInfo">
            <div className='main_profile_container'>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faUser} className="icon" />
                    </div>
                    <div className='text_holder'>
                        <p className='username'>Pratik Mohol</p>
                        <p className='contact'>+968 9876543210</p>
                    </div>
                </div>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faLocationDot} className="icon" />
                    </div>
                    <div className='text_holder'>
                        <p className='address'>7, Bader Mohammad Nasser Al Sayer Street, Block 3 Abdullah Al-Salem, Kuwait City, Al Asimah, 25501</p>
                    </div>
                </div>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faHandHoldingDollar} className='icon' />
                    </div>
                    <div className='text_holder'>
                        <p className='pay'>Google Pay</p>
                    </div>
                </div>
            </div>



        </section>
    )
}

export default UserInfo
